import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import { getSplashTheme } from "@/lib/splashThemes";
import { SplashStage } from "./SplashStage";

const KEY = "757-splash-seen";

const preload = (src) => new Promise((resolve) => { if (!src) return resolve(); const img = new Image(); img.onload = img.onerror = resolve; img.src = src; });

/** Splash intro shown once per visit, using the theme Rob picked in the admin panel. */
export const SplashScreen = () => {
  const { pathname } = useLocation();
  const [show, setShow] = useState(() => {
    try { return sessionStorage.getItem(KEY) !== "1" && !pathname.startsWith("/admin"); } catch { return false; }
  });
  const [leaving, setLeaving] = useState(false);
  const [ready, setReady] = useState(false);
  const [themeId, setThemeId] = useState(null);
  const theme = getSplashTheme(themeId);
  useEffect(() => { if (show) api.get("/splash-theme").then(({ data }) => setThemeId(data.theme_id)).catch(() => setThemeId("patriotic")); }, [show]);
  useEffect(() => {
    if (!show || !themeId) return undefined;
    let live = true;
    const font = document.fonts?.load ? document.fonts.load("700 132px Cinzel") : Promise.resolve();
    Promise.race([Promise.all([font, preload(theme.art)]), new Promise((r) => setTimeout(r, 1800))]).catch(() => {}).then(() => live && setReady(true));
    return () => { live = false; };
  }, [show, themeId, theme.art]);
  useEffect(() => {
    if (!show || !ready) return undefined;
    try { sessionStorage.setItem(KEY, "1"); } catch { /* ignore */ }
    document.body.style.overflow = "hidden";
    const t = setTimeout(() => setLeaving(true), theme.duration - 600);
    return () => { clearTimeout(t); document.body.style.overflow = ""; };
  }, [show, ready, theme.duration]);
  useEffect(() => {
    if (!leaving) return undefined;
    const t = setTimeout(() => setShow(false), 650);
    return () => clearTimeout(t);
  }, [leaving]);
  if (!show) return null;
  if (!ready) return <div className="splash-root fixed inset-0 z-[100]" data-testid="splash-loading" />;

  return (
    <SplashStage theme={theme} leaving={leaving} testId="splash-screen">
      <button type="button" onClick={() => setLeaving(true)} data-testid="splash-skip"
        className="absolute bottom-[8cqh] right-6 z-10 rounded-full border border-white/30 bg-black/20 px-4 py-1.5 text-[12px] uppercase tracking-widest text-white/80 backdrop-blur transition-colors hover:bg-white hover:text-[#0A1630]">
        Skip
      </button>
    </SplashStage>
  );
};
